<ng-container *transloco="let t; prefix: 'documents.scoring-metrics.overtime-section'">
  <app-document-scoring-metrics-section
    [panel]="panel()"
    (expandedChanged)="onExpandedChanged($event)"
  >
    <div class="document-scoring-overtime__wrapper">
      <xi-dropdown
        [data]="metricOptions()"
        [groups]="metricOptionGroups()"
        label="{{ t('metric') }}"
        [(value)]="selectedMetric"
      ></xi-dropdown>

      <xi-dropdown
        [data]="metricGroupByOptions()"
        label="{{ t('group-by') }}"
        [(value)]="selectedMetricGroupBy"
      ></xi-dropdown>

      @if (selectedMetric() === 'nlp-sentiment') {
        <xi-dropdown
          [data]="metricSpeakerOptions()"
          label="{{ t('speaker') }}"
          [(value)]="selectedMetricSpeaker"
        ></xi-dropdown>
      }

      <div class="document-scoring-overtime__chart-header">
        {{ chartTitle() }}
      </div>
      <div
        class="document-scoring-overtime__chart"
        [class.document-scoring-overtime__chart--hidden]="isChartEmpty()"
      >
        <div #metricChart class="document-scoring-overtime__chart-content"></div>

        @if (isChartEmpty()) {
          <div class="document-scoring-overtime__chart-empty">
            {{ t('no-data') }}
          </div>
        }
      </div>

      <div
        class="document-scoring-overtime__number"
        [class.document-scoring-overtime__number--hidden]="isChartEmpty()"
      >
        <div class="document-scoring-overtime__number-header">
          {{ totalChangeLabel() }}
        </div>

        <div
          class="document-scoring-overtime__number-value"
          [class.document-scoring-overtime__number-value--positive]="totalChangeValue() > 0"
          [class.document-scoring-overtime__number-value--negative]="totalChangeValue() < 0"
        >
          {{ totalChangeValueSign() }}{{ totalChangeValue() | number: '1.0-2' }}
        </div>
      </div>
    </div>
  </app-document-scoring-metrics-section>
</ng-container>
